import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { TecnicoResponsable } from './entity-tecnico-responsable.model';

// LOAD
export const entityTecnicoResponsableLoadRequest = createAction(
  '[ENTITYTECNICORESPONSABLE] Load Request'
);

export const entityTecnicoResponsableLoadFailure = createAction(
  '[ENTITYTECNICORESPONSABLE] Load Failure',
  props<{ error: Error }>()
);

export const entityTecnicoResponsableLoadSuccess = createAction(
  '[ENTITYTECNICORESPONSABLE] Load Success',
  props<{ items: TecnicoResponsable[] }>()
);

// ADD
export const entityTecnicoResponsableAddRequest = createAction(
  '[ENTITYTECNICORESPONSABLE] Add Request',
  props<{ item: TecnicoResponsable }>()
);

export const entityTecnicoResponsableAddFailure = createAction(
  '[ENTITYTECNICORESPONSABLE] Add Failure',
  props<{ error: Error }>()
);

export const entityTecnicoResponsableAddSuccess = createAction(
  '[ENTITYTECNICORESPONSABLE] Add Success',
  props<{ item: TecnicoResponsable }>()
);

// CHANGE
export const entityTecnicoResponsableChangeRequest = createAction(
  '[ENTITYTECNICORESPONSABLE] Change Request',
  props<{ item: TecnicoResponsable }>()
);

export const entityTecnicoResponsableChangeFailure = createAction(
  '[ENTITYTECNICORESPONSABLE] Change Failure',
  props<{ error: Error }>()
);

export const entityTecnicoResponsableChangeSuccess = createAction(
  '[ENTITYTECNICORESPONSABLE] Change Success',
  props<{ item: Update<TecnicoResponsable> }>()
);

// DELETE
export const entityTecnicoResponsableDeleteRequest = createAction(
  '[ENTITYTECNICORESPONSABLE] Delete Request',
  props<{ item: TecnicoResponsable }>()
);

export const entityTecnicoResponsableDeleteFailure = createAction(
  '[ENTITYTECNICORESPONSABLE] Delete Failure',
  props<{ error: Error }>()
);

export const entityTecnicoResponsableDeleteSuccess = createAction(
  '[ENTITYTECNICORESPONSABLE] Delete Success',
  props<{ item: TecnicoResponsable }>()
);
